<template>
  <div>

    <!-- Top Info Grid -->
    <section class="top-info py-2">
      <b-container>
        <b-row class="text-center align-items-center">
          <b-col md="4" class="info-item">
            <strong>Our Office</strong><br />
            <small>laaga rd 4 elepe ikorodu, Lagos stste</small>
          </b-col>

          <b-col md="4" class="info-item">
            <strong>Email Us</strong><br />
            <small>olaleresomod24@gmail.com</small>
          </b-col>

          <b-col md="4" class="info-item">
            <strong>Contact Us</strong><br />
            <small>+234 800 123 4567</small>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <!-- NAVBAR -->
    <b-navbar toggleable="lg" type="dark" variant="dark" class="bg-dark">
      <b-navbar-brand to="/">JEWELUX</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" />
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item to="/">Home</b-nav-item>
          <b-nav-item to="/shop">Shop</b-nav-item>
          <b-nav-item to="/about">About Us</b-nav-item>
          <b-nav-item to="/partners">Partners</b-nav-item>
          <b-nav-item to="/contact">contacts</b-nav-item>
          <b-nav-item to="/cart">cart</b-nav-item>
        </b-navbar-nav>


      </b-collapse>
    </b-navbar>


    <!-- HERO -->
    <section class="hero-checkout text-white text-center">
      <img class="img testimonial-img" src="../assets/person_1.jpg" />
      <div class="overlay">
        <h1>Checkout</h1>
        <p>Complete your order securely</p>
      </div>
    </section>

    <!-- CHECKOUT FORM -->
    <section class="container py-5">
      <b-form @submit.prevent="submitOrder" ref="checkoutForm">
        <b-row>
          <b-col md="6">
            <b-form-group label="Full Name" label-for="fullName" description="Enter your full name" :state="nameState">
              <b-form-input id="fullName" v-model="form.name" :state="nameState" required></b-form-input>
              <b-form-invalid-feedback>Name is required</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Email" label-for="email" description="Enter your email" :state="emailState">
              <b-form-input id="email" type="email" v-model="form.email" :state="emailState" required></b-form-input>
              <b-form-invalid-feedback>Valid email is required</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Address" label-for="address" :state="addressState">
              <b-form-textarea id="address" v-model="form.address" :state="addressState" rows="3"
                required></b-form-textarea>
              <b-form-invalid-feedback>Address is required</b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <h5>Order Summary</h5>
            <ul class="list-group mb-3">
              <li class="list-group-item" v-for="(item, index) in cart" :key="index">
               
                {{ item.name }} - ${{ item.price }} x {{ item.qty }}
                <span class="float-right">${{ item.price * item.qty }}</span>
              </li>
            </ul>
            <h5 class="text-right">Total: ${{ grandTotal }}</h5>
          </b-col>
        </b-row>

        <div class="text-center mt-4">
          <b-button type="submit" variant="dark">Place Order</b-button>
        </div>
      </b-form>
    </section>
    <!---Modern Footer -->
    <b-container fluid class="bg-dark text-white pt-5 pb-3">
      <b-row class="text-center text-md-left">

        <!-- Brand / Logo -->
        <b-col md="3" class="mb-4">
          <h4 class="text-gold font-weight-bold">JEWELUX</h4>
          <p class="small">Luxury handcrafted jewelry for every occasion.</p>
        </b-col>

        <!-- Quick Links -->
        <b-col md="3" class="mb-4">
          <h5 class="text-uppercase">Quick Links</h5>
          <ul class="list-unstyled">
            <li><a href="#" class="text-white">Home</a></li>
            <li><a href="#" class="text-white">Shop</a></li>
            <li><a href="#" class="text-white">About</a></li>
            <li><a href="#" class="text-white">Contact</a></li>
          </ul>
        </b-col>

        <!-- Social Media -->
        <b-col md="3" class="mb-4">
          <h5 class="text-uppercase">Follow Us</h5>
          <div>
            <b-icon icon="facebook" font-scale="1.5" class="mr-2 text-white"></b-icon>
            <b-icon icon="instagram" font-scale="1.5" class="mr-2 text-white"></b-icon>
            <b-icon icon="twitter" font-scale="1.5" class="mr-2 text-white"></b-icon>
          </div>
        </b-col>

        <!-- Newsletter -->
        <b-col md="3" class="mb-4">
          <h5 class="text-uppercase">Newsletter</h5>
          <b-form @submit.prevent="subscribe">
            <b-input-group size="sm">
              <b-form-input v-model="email" type="email" placeholder="Your email" required></b-form-input>
              <b-input-group-append>
                <b-button type="submit" variant="gold">Subscribe</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form>
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col class="text-center small">
          &copy; 2026 JEWELUX. All rights reserved.
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'CheckoutPage',
  data() {
    return {
      cart: [],
      form: {
        name: '',
        email: '',
        address: ''
      }
    }
  },
  computed: {
    grandTotal() {
      return this.cart.reduce((sum, item) => sum + item.price * item.qty, 0)
    },
    nameState() {
      return this.form.name.length > 0 ? true : null
    },
    emailState() {
      const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return pattern.test(this.form.email) ? true : null
    },
    addressState() {
      return this.form.address.length > 0 ? true : null
    }
  },
  mounted() {
    const savedCart = JSON.parse(localStorage.getItem('cart')) || []
    this.cart = savedCart.map(item => ({ ...item, qty: item.qty || 1 }))
  },
  methods: {
    submitOrder() {
      if (this.$refs.checkoutForm.checkValidity()) {
        alert('Order placed successfully!')
        localStorage.removeItem('cart')
        this.cart = []
        this.form = { name: '', email: '', address: '' }
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.hero-checkout {
  position: relative;
  height: 60vh;
}

.hero-checkout img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-checkout .overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.bg-black {
  background: #000;
}

.img {
  width: 100%;
  border-radius: 12px;
}


/* Footer Styling */
.text-gold {
  color: #bfa14b;
}
</style>